import { useRef, useState } from 'react'
import { Button, Result, Form, Input, message } from 'antd'
import Api from '../../api/index'
import { verificationCodeIntervalTime } from '../../setting'
import {
  WECHAT_QR_EXPIRED_CODE,
  getApiCode,
  getApiMessage,
  getApiPayload,
  getErrorCode,
} from '../../utils/wechatQr'

export default function Register(props) {
  const {
    closeWin,
    scanId,
    codeType,
    registrationToken,
    onRegistrationTokenConsumed,
    onExpired,
  } = props
  const [isConfirm, setIsConfirm] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const submittingRef = useRef(false)
  const registrationValuesRef = useRef(null)
  const [form] = Form.useForm()
  const [countdownSecond, setCountdownSecond] = useState(0)
  const [registerStatus, setRegisterStatus] = useState(1)

  const setSMSCountdownTimer = (time) => {
    if (window.SMSCountdownTimer) {
      clearTimeout(window.SMSCountdownTimer)
      window.SMSCountdownTimer = null
    }
    const oldSMSCountdownSecond = window.localStorage.getItem(
      'SMSCountdownSecond'
    )
    const diff = time - oldSMSCountdownSecond
    if (diff > verificationCodeIntervalTime * 1000) return
    let intervalTime = verificationCodeIntervalTime * 1000 - diff
    intervalTime = Math.max(0, parseInt(intervalTime / 1000))
    setCountdownSecond(intervalTime)
    if (intervalTime > 0) {
      window.SMSCountdownTimer = setTimeout(
        () => setSMSCountdownTimer(new Date().getTime()),
        1000
      )
    }
  }

  const sendingSMS = () => {
    form.validateFields(['phoneNumber']).then(({ phoneNumber }) => {
      Api.getVerifyCode({ phone: phoneNumber, type: 3 }).then((res) => {
        if (res.data?.code === 0) {
          window.localStorage.setItem('SMSCountdownSecond', new Date().getTime())
          setSMSCountdownTimer(new Date().getTime())
        } else {
          message.error(res.data.msg)
        }
      })
    })
  }

  const handleExpired = () => {
    onExpired()
  }

  const createFunc = async (confirmCreateCompany = false) => {
    if (submittingRef.current || !registrationToken) return
    submittingRef.current = true
    setSubmitting(true)
    try {
      const values = confirmCreateCompany
        ? registrationValuesRef.current
        : await form.validateFields()
      if (!values) return
      if (!confirmCreateCompany) registrationValuesRef.current = values
      const { enterpriseName, phoneNumber, verificationCode } = values
      const res = await Api.registerWechatQr({
        scan_id: scanId,
        registration_token: registrationToken,
        phone: phoneNumber,
        company_name: enterpriseName,
        confirm_create_company: confirmCreateCompany,
        ...(confirmCreateCompany ? {} : { verify_code: verificationCode }),
      })
      const code = getApiCode(res)
      if (code === WECHAT_QR_EXPIRED_CODE) {
        handleExpired()
        return
      }
      if (code !== undefined && code !== null && code !== 0) {
        message.error(getApiMessage(res) || '注册失败，请稍后重试')
        return
      }

      const status = getApiPayload(res)?.status
      if (status === 'registered') {
        setRegisterStatus(1)
        setIsConfirm(true)
        onRegistrationTokenConsumed()
      } else if (status === 'already_has_company') {
        setRegisterStatus(2)
        setIsConfirm(true)
      } else if (status === 'company_limit_reached') {
        setRegisterStatus(3)
        setIsConfirm(true)
      } else {
        message.error(getApiMessage(res) || '注册失败，请稍后重试')
      }
    } catch (error) {
      if (error?.errorFields) return
      if (getErrorCode(error) === WECHAT_QR_EXPIRED_CODE) {
        handleExpired()
      } else {
        message.error(error?.response?.data?.msg || '注册失败，请稍后重试')
      }
    } finally {
      submittingRef.current = false
      setSubmitting(false)
    }
  }

  return (
    <div
      className="registerContentBox"
      style={{ height: isConfirm ? 'auto' : '100%' }}
      data-code-type={codeType}
    >
      {!isConfirm ? (
        <div className="formBox">
          <Form colon={false} layout="vertical" autoComplete="off" form={form}>
            <Form.Item
              label="企业或组织名称"
              name="enterpriseName"
              rules={[{ required: true, message: '企业或组织名称不能为空' }]}
            >
              <Input placeholder="请输入企业或组织名称" />
            </Form.Item>
            <Form.Item
              label="手机号"
              name="phoneNumber"
              rules={[
                { required: true, message: '手机号不能为空' },
                {
                  pattern:
                    /^(13\d|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18\d|19[0-35-9])\d{8}$/,
                  message: '手机号格式不对',
                },
              ]}
            >
              <Input placeholder="请输入手机号" />
            </Form.Item>
            <Form.Item
              label="验证码"
              name="verificationCode"
              rules={[{ required: true, message: '验证码不能为空' }]}
            >
              <div style={{ display: 'flex' }}>
                <Input
                  style={{ width: 'calc(100% - 84px)', marginRight: '8px' }}
                  placeholder="请输入验证码"
                />
                <Button
                  type="primary"
                  onClick={sendingSMS}
                  disabled={Boolean(countdownSecond) || submitting}
                >
                  {countdownSecond ? `${countdownSecond}s后重试` : '获取验证码'}
                </Button>
              </div>
            </Form.Item>
          </Form>
          <Button
            className="creatBtn"
            type="primary"
            onClick={() => createFunc(false)}
            loading={submitting}
            disabled={submitting || !registrationToken}
          >
            创建
          </Button>
        </div>
      ) : (
        <div className="registerContent">
          <Result
            status="success"
            title={
              registerStatus === 1
                ? '注册成功'
                : registerStatus === 2
                ? '您已经注册过企业/组织'
                : '同一个账号最多可以注册5个企业或组织'
            }
            subTitle={registerStatus === 2 ? '是否需要继续注册？' : null}
          />
          {registerStatus === 1 && (
            <Button type="primary" className="loginBtn" onClick={closeWin}>
              完成
            </Button>
          )}
          {registerStatus === 2 && (
            <>
              <Button
                type="primary"
                className="loginBtn"
                onClick={() => createFunc(true)}
                loading={submitting}
                disabled={submitting}
              >
                需要
              </Button>
              <Button
                className="closeBtn"
                onClick={closeWin}
                disabled={submitting}
              >
                不需要
              </Button>
            </>
          )}
          {registerStatus === 3 && (
            <Button type="primary" className="loginBtn" onClick={closeWin}>
              好的
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
